import React from 'react';
import MultipleEmployeeApproval from './MultipleEmployeeApproval';
import { AiOutlineClose } from "react-icons/ai";
// import DropOutModal from '../../../components/ModalComponents/DropOutModal';
// import ShareModal from '../../../components/ModalComponents/ShareModal';
import ScreeningModal from '../../../components/ModalComponents/ScreeningModal';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

function ScreeningDrawerComponent({ isOpen, onClose, data, id }: any) {
	const drawerClassName = `drawer-container ${isOpen ? 'drawer-open' : ''}`;

	return (
		<div className={drawerClassName}>
			<div className='times_container'>
				<div className='times_container_sup'>
					<h2>New Applicants</h2>
					<div className="dropdown">
						<button className="dropbtn">
							<MoreHorizIcon />
						</button>
						<div className="dropdown-content">
							<a>
								<ScreeningModal
									title="Send for Screening"
									name={data}
									id={id}
								/>
							</a>

							{/* <a>
								<DropOutModal
									title="Dropout"
									id={id}
									name={data}
								/>
							</a>

							<a>
								<ShareModal
									title="Share" applicationId={undefined}
								/>
							</a> */}
						</div>
					</div>
				</div>
				<button onClick={onClose} className="close-button">
					<AiOutlineClose />
				</button>
			</div>

			<div className="drawer-content">
				{/* Add your drawer content here */}
				<MultipleEmployeeApproval data={data} />
			</div>
		</div>
	);
}

export default ScreeningDrawerComponent;